import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileuploadComponent } from './mobileupload/mobileupload.component';
import { CmsConfig, ConfigModule } from '@spartacus/core';



@NgModule({
  declarations: [
    MobileuploadComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusQRScannerMobileComponent: {
          component: MobileuploadComponent
        },
        
      }
    } as CmsConfig)
  ]
})
export class MobileuploadpageModule { }
